// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IRoleLiteDto
 */
export interface IRoleLiteDto {
    /**
     * 
     * @type {number}
     * @memberof IRoleLiteDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IRoleLiteDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IRoleLiteDto
     */
    level_type?: IRoleLiteDtoLevelTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IRoleLiteDtoLevelTypeEnum {
    ELEVATE = 'ELEVATE',
    GLOBAL = 'GLOBAL',
    PARTNER = 'PARTNER'
}


/**
 * Check if a given object implements the IRoleLiteDto interface.
 */
export function instanceOfIRoleLiteDto(value: object): value is IRoleLiteDto {
    return true;
}

export function IRoleLiteDtoFromJSON(json: any): IRoleLiteDto {
    return IRoleLiteDtoFromJSONTyped(json, false);
}

export function IRoleLiteDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRoleLiteDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'level_type': json['level_type'] == null ? undefined : json['level_type'],
    };
}

export function IRoleLiteDtoToJSON(json: any): IRoleLiteDto {
    return IRoleLiteDtoToJSONTyped(json, false);
}

export function IRoleLiteDtoToJSONTyped(value?: IRoleLiteDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'level_type': value['level_type'],
    };
}

